import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 登录
 * @param {*} params
 */
export function login(data) {
  return request({
    url: BASE_API() + '/login',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  })
}

/**
 * 单点登录
 * @param {*} params
 */
export function soologin(data) {
  return request({
    url: BASE_API() + '/ssoLogin',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  })
}

/**
 * 登出
 * @param {*} params
 */
export function logout(data) {
  return request({
    url: BASE_API() + '/logout',
    method: 'post',
    data: data
  })
}

/**
 * 获取用户菜单路由
 */
export function getUserRoutes() {
  return request({
    url: BASE_API() + '/authorizedRoute',
    method: 'get'
  })
}

/**
 * 获取用户菜单路由
 */
export function getUserRoutes1(params) {
  return request({
    url: BASE_API() + '/Invinfo/exportPDF',
    method: 'get',
    params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js